module.exports = __webpack_public_path__ + "static/media/Superficial.f663b95d.svg";